import React, { CSSProperties, useContext, useEffect } from "react";

import Layout, { EmbeddedLayout } from "./layout/Layout";
import { Outlet, useNavigate } from "react-router-dom";
import { ISessionStateContext, SessionStateContext } from "../../Core/State/SessionStateContext";
import { AppStateProvider } from "../../Core/State/ChatbotAppProvider";
import Chat from "./chat/Chat";
import { mergeStyles, MotionAnimations, MotionDurations, Panel, PanelType, Stack } from "@fluentui/react";

export interface IChatbotProps {
    chatContainerStyles?: string;
    chatInnerContainerStyles?: string;
    embedded?: boolean;
    displayAppNavbar: boolean;
    hideChatbotNavbar: boolean;
}

export const Chatbot: React.FC<IChatbotProps> = (props) => {
    const navigate = useNavigate();
    const sessionInfoContexrt: ISessionStateContext = useContext(SessionStateContext);

    const embeddedLayoutStyle = mergeStyles([{
        height: '98.25dvh',
        margin: "0",
        containerType: "size"
    }]);

    useEffect(() => {
        if(!props.embedded){
            let baseUrl: string = sessionInfoContexrt.currentApp.homepageUrl.substring(0, sessionInfoContexrt.currentApp.homepageUrl.lastIndexOf("/"));
            let queryString: string = window.location.search;
            let url: string = baseUrl + "/chatbot/chat" + queryString;
            
            navigate(url);
        }
    }, []);

    return (
        <>
            {
                !props.embedded ? 
                    <Layout 
                        displayAppNavbar={props.displayAppNavbar}
                        hideChatbotNavbar={props.hideChatbotNavbar}
                    >
                        <Outlet/>
                    </Layout>
                :
                <AppStateProvider>
                    <Stack
                        className={embeddedLayoutStyle}
                    >
                        <Chat
                            containerStyles={props.chatContainerStyles}
                            innerContainerStyles={props.chatInnerContainerStyles}
                            isEmbedded 
                        />
                    </Stack>
                </AppStateProvider>
            }
        </>
    );
}

//#region Chatbot panel

export interface IChatbotPanelProps {
    isOpen: boolean;
    customStyle?: CSSProperties;
    onDismiss: () => void;
}

export const ChatbotPanel : React.FC<IChatbotPanelProps> = (props) => {
    const roleCenterHelpPanelClassName = mergeStyles([{
        top: "52px !important",
        height: 'calc(100% - 51px) !important',
        zIndex: "10 !important",
    }]);
    
    const panelContainerClassName = mergeStyles([{
        overflow: 'hidden',
        height: '100%'
    }]);

    return (
        <Panel
            styles={{
                content:{
                    paddingBottom: 0,
                    paddingLeft: 0,
                    paddingRight: 0,
                    height: 'calc(100% - 50px)'
                },
                contentInner: {
                    height: '100%'
                },
                scrollableContent: {
                    height: '100%'
                },
                main:{
                    boxShadow: 'none !important',
                    backgroundColor:'#FAF9F8',
                    borderLeft: "1px solid #bababa"
                },
                commands:{
                    boxShadow: 'none !important',
                    backgroundColor:'#FAF9F8'
                },
                root:{
                    zIndex: 10
                }
            }}
            layerProps={{ styles: { root: { zIndex: props.customStyle?.zIndex ? props.customStyle.zIndex : 10000 }}}}
            className={roleCenterHelpPanelClassName}
            isOpen={props.isOpen}
            isBlocking={false}
            onDismiss={props.onDismiss}
            headerText="Chatbot"
            customWidth={'20%'}
            onRenderHeader={() => <></>}
            type={PanelType.custom}
        >
            <Stack className={panelContainerClassName}>
                <EmbeddedLayout />
            </Stack>
        </Panel>
    )
}

//#endregion